<template>
    <b-modal @hidden="clear" v-model="show" id="enterItemModal" centered :title="$t('tab_add_item_title')">
      <b-form class="enter-item-form">
        <info-row class="info-main-row" :sizing="4" :title="$t('tab_add_item_add_label')">
          <b-col sm="8" class="input-group">
            <b-form-select :state="fieldState.selectedItemType" :title="'Item Type'" :options="selectableItems"
            @change="populateInfo" class="form-control" :value="selectedItemType" v-model="selectedItemType" required/>
          </b-col>
        </info-row>

        <info-row class="info-main-row" :sizing="4" :title="$t('tab_add_item_cost_label')">
          <!-- TODO: Find a way to clear this without v-if from inside the component -->
          <currency-input disabled v-if="show" ref="costInput" name="Cost" :amount.sync="amount" :fieldState="fieldState.amount"/>
        </info-row>

        <info-row class="info-main-row" :sizing="4" :title="$t('tab_add_item_description_label')">
          <b-col sm="8" class="input-group bill-field">
            <b-form-input type="text" :title="'description'" min="0" :state="fieldState.description"
            class="form-control" :value="description" v-model="description" required/>
          </b-col>
        </info-row>
      </b-form>
      <div slot="modal-footer" class="w-100">
        <span class="text-danger">{{warningText}}</span>
        <b-btn class="float-right" variant="success" @click="triggerItem()">
          {{$t('tab_add_item_button')}}
        </b-btn>
      </div>
    </b-modal>
</template>

<script>
  import InfoRow from "@/components/InfoRow";
  import { PAYMENT_TYPES, PAYMENT_METHODS } from "@/config/constants"
  import CurrencyInput from "@/components/widgets/CurrencyInput";

  export default {
    name: "EnterItemModal",
    props: {
      items: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        show: null,
        amount: 0,
        description: '',
        warningText: "",
        selectedItemType: "",
        selectedItemMethod: "",
        itemTypes: [
          {text: "Deposit", value: PAYMENT_TYPES.DEPOSIT},
          {text: "Payment", value: PAYMENT_TYPES.PAYMENT}
        ],
        itemMethods: [
          {text: "Stripe", value: PAYMENT_METHODS.STRIPE},
          {text: "Manual", value: PAYMENT_METHODS.MANUAL}
        ],
        fieldState: { //true is valid, false shows the red invalid
          amount: null,
          selectedItemType: null,
          selectedItemMethod: null
        },
        systemPaymentMethods: PAYMENT_METHODS
      }
    },
    methods: {
      populateInfo(selection) {
        this.amount = parseFloat(this.items.find(item => item.id === selection).default_rate);
        this.description = this.items.find(item => item.id === selection).description;
      },
      triggerItem(selectedItems) {
        this.fieldState.amount = !!this.amount && this.amount > 0
        this.fieldState.description = !!this.description
        this.fieldState.selectedItemType = !!this.selectedItemType

        if (this.fieldState.amount && this.fieldState.selectedItemType && this.fieldState.description){
          this.submitItem();
        } else {
          this.warningText = "Item, amount and description are required"
        }
      },
      submitItem() {
        const itemData = {
          item_id: this.selectedItemType,
          description: this.description,
          rate: this.amount,
          name: this.selectableItems.find(item => item.value === this.selectedItemType).text
        }

        this.$emit("submit", itemData)
        this.clear()
        this.show = false
      },
      selectedItemMethodLabel() {
        return this.itemMethods.find(method => method.value === this.selectedItemMethod).text
      },
      selectedItemTypeLabel() {
        return this.itemTypes.find(method => method.value === this.selectedItemType).text
      },
      setAmount(newAmount) {
        this.amount = newAmount
      },
      setItemType(itemType) {
        this.selectedItemType = itemType
      },
      clear() {
        this.amount = 0;
        this.warningText = "";
        this.selectedItemType = "";
        this.description = "";
        this.fieldState = {
          amount: null,
          selectedItemType: null
        }
      }
    },
    components: {
      InfoRow, CurrencyInput
    },
    computed: {
      selectableItems() {
        return this.items.map(item => { return {text: item.name, value: item.id}})
      }
    }
  };
</script>

<style lang="scss">
  #enterItemModal {
      .modal-header {
        height: initial;
        width: initial;
      }
      .modal-open {
        margin: auto;
      }
  }
</style>
